import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { Button, Popover } from 'antd';
import { FaUserCircle } from "react-icons/fa";
import { FaMobileAlt, FaTabletAlt, FaLaptop } from "react-icons/fa";
import { MdDevices } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { changeUpdateLayoutFromPageAction } from '../redux/actions';
import _ from 'underscore';

interface ProfileMenuItem {
    label: string;
    icon: string;
    redirectTo: string;
}

const ResponSiveDropDown = () => {
    const dispatch = useDispatch();
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
    const { isChangeLayout, layoutBreakpoint, layout } = useSelector((state:any) => state.DashboardPage, _.isEqual);

    const handleSizeChange = (newSize:any) => {        
        switch (newSize) {
          case 'lg':
            dispatch(changeUpdateLayoutFromPageAction('lg'));
            break;
          case 'md':
            dispatch(changeUpdateLayoutFromPageAction('md'));
            break;
          case 'sm':
            dispatch(changeUpdateLayoutFromPageAction('sm'));
            break;
          case 'xs':
            dispatch(changeUpdateLayoutFromPageAction('xs'));
            break;
          default:
            dispatch(changeUpdateLayoutFromPageAction('lg'));
        }        
      };
    /*
     * toggle profile-dropdown
     */
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
   
    const content = (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight:15, marginLeft:15 }}>
          <Button className="sanjabIcon" style={{ width: 20, marginLeft: 15 }} onClick={() => handleSizeChange('lg')} type="link" icon={<FaLaptop style={{ fontSize: 24, color: layoutBreakpoint === "lg" ? '#27ae60' : 'rgba(0, 0, 0, 0.45)' }} />} />
          <Button className="sanjabIcon" style={{ width: 20, marginLeft: 15 }} onClick={() => handleSizeChange('md')} type="link" icon={<FaTabletAlt style={{ fontSize: 18, color: layoutBreakpoint === "md" ? '#27ae60' : 'rgba(0, 0, 0, 0.45)' }} />} />
          <Button className="sanjabIcon" style={{ width: 20, marginLeft: 15 }} onClick={() => handleSizeChange('sm')} type="link" icon={<FaMobileAlt style={{ fontSize: 20, color: layoutBreakpoint === "sm" ? '#27ae60' : 'rgba(0, 0, 0, 0.45)', transform: 'rotate(270deg)' }} />} />
          <Button className="sanjabIcon" style={{ width: 20 }} onClick={() => handleSizeChange('xs')} type="link" icon={<FaMobileAlt style={{ fontSize: 20, color: layoutBreakpoint === "xs" ? '#27ae60' : 'rgba(0, 0, 0, 0.45)' }} />} />
        </div>
    )

    return (
        <Popover placement="left" content={content} trigger="hover"   overlayInnerStyle={{ marginBottom:10, marginRight:10, backgroundColor:'#fbf9f9'}}>

            {/* <Button  size='small' type='text'    icon={<FaUserCircle style={{ fontSize: '22',color:'white' }} />} /> */}
            <div className="sanjabRightsidebar">
                <MdDevices style={{ fontSize: 22, color: 'white' }} />
            </div>




        </Popover>
        // <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
        //     <Dropdown.Toggle
        //         id="dropdown-profile"
        //         as="a"
        //         onClick={toggleDropdown}
        //         className={classNames('nav-link', 'nav-user', 'me-0', 'cursor-pointer', { show: dropdownOpen })}>
        //             <span className="pro-user-name ms-2">
        //             <i className="uil uil-angle-down"></i>
        //             {/* {props.username}  */}
        //         </span>
        //         <img src={profilePic!} className="rounded-circle" alt="" />

        //     </Dropdown.Toggle>
        //     <Dropdown.Menu className="dropdown-menu-end profile-dropdown">
        //         <div onClick={toggleDropdown}>
        //             {/* <div className="dropdown-header noti-title">
        //                 <h6 className="text-overflow m-0">داشبورد مدیریت سی جاب</h6>
        //             </div> */}
        //             {(props.menuItems || []).map((item, i) => {
        //                 return (
        //                     <React.Fragment key={i}>
        //                         {i === props.menuItems.length - 1 && <div className="dropdown-divider"></div>}
        //                         <Link
        //                             to={item.redirectTo}
        //                             className="dropdown-item notify-item"
        //                             key={i + '-profile-menu'}>
        //                             <FeatherIcon icon={item.icon} className="icon-dual icon-xs ms-1" />
        //                             <span>{item.label}</span>
        //                         </Link>
        //                     </React.Fragment>
        //                 );
        //             })}
        //         </div>
        //     </Dropdown.Menu>
        // </Dropdown>
    );
};

export default ResponSiveDropDown;
